import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, Transition as _Transition } from "vue"
import _imports_0 from '@/assets/logo-final.png'


const _hoisted_1 = { class: "sticky top-0 z-50 bg-white shadow-sm" }
const _hoisted_2 = { class: "bg-brand text-white text-sm py-2 hidden md:block" }
const _hoisted_3 = { class: "max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex justify-between items-center" }
const _hoisted_4 = { class: "flex items-center gap-1" }
const _hoisted_5 = { class: "max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" }
const _hoisted_6 = { class: "flex items-center justify-between h-16" }
const _hoisted_7 = { class: "hidden md:flex items-center gap-4 lg:gap-8 font-medium text-accent" }
const _hoisted_8 = { class: "flex items-center gap-3" }
const _hoisted_9 = {
  key: 0,
  class: "absolute -top-1 -right-1 bg-brand text-white text-xs font-bold w-4 h-4 sm:w-5 sm:h-5 rounded-full flex items-center justify-center"
}
const _hoisted_10 = {
  key: 0,
  class: "md:hidden pb-4 border-t border-cream-200 pt-3"
}
const _hoisted_11 = { class: "flex flex-col gap-1 font-medium text-accent" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PhoneIcon = _resolveComponent("PhoneIcon")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_ShoppingCartIcon = _resolveComponent("ShoppingCartIcon")!
  const _component_Bars3Icon = _resolveComponent("Bars3Icon")!
  const _component_XMarkIcon = _resolveComponent("XMarkIcon")!

  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[5] || (_cache[5] = _createElementVNode("span", null, "Free delivery on orders over 5,000 Rwf", -1)),
        _createElementVNode("span", _hoisted_4, [
          _createVNode(_component_PhoneIcon, { class: "w-4 h-4" }),
          _cache[4] || (_cache[4] = _createTextVNode(" +250 788 288 199 ", -1))
        ])
      ])
    ]),
    _createElementVNode("nav", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_router_link, {
          to: "/",
          class: "flex items-center gap-2 flex-shrink-0"
        }, {
          default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
            _createElementVNode("img", {
              src: _imports_0,
              alt: "HomeSweet Bites",
              class: "h-12 w-auto"
            }, null, -1)
          ]))]),
          _: 1
        }),
        _createElementVNode("ul", _hoisted_7, [
          _createElementVNode("li", null, [
            _createVNode(_component_router_link, {
              to: "/",
              class: "hover:text-brand transition-colors duration-150",
              "active-class": "text-brand font-semibold"
            }, {
              default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                _createTextVNode("Home", -1)
              ]))]),
              _: 1
            })
          ]),
          _createElementVNode("li", null, [
            _createVNode(_component_router_link, {
              to: "/menu",
              class: "hover:text-brand transition-colors duration-150",
              "active-class": "text-brand font-semibold"
            }, {
              default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                _createTextVNode("Today's Menu", -1)
              ]))]),
              _: 1
            })
          ]),
          _createElementVNode("li", null, [
            _createVNode(_component_router_link, {
              to: "/about",
              class: "hover:text-brand transition-colors duration-150",
              "active-class": "text-brand font-semibold"
            }, {
              default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                _createTextVNode("About Us", -1)
              ]))]),
              _: 1
            })
          ]),
          _createElementVNode("li", null, [
            _createVNode(_component_router_link, {
              to: "/contact",
              class: "hover:text-brand transition-colors duration-150",
              "active-class": "text-brand font-semibold"
            }, {
              default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                _createTextVNode("Contact", -1)
              ]))]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("button", {
            class: "relative p-2 rounded-xl hover:bg-cream-200 transition-colors duration-150",
            "aria-label": "View cart",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('open-cart')))
          }, [
            _createVNode(_component_ShoppingCartIcon, { class: "w-6 h-6 text-accent" }),
            (_ctx.cartCount > 0)
              ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_ctx.cartCount), 1))
              : _createCommentVNode("", true)
          ]),
          _createVNode(_component_router_link, {
            to: "/menu",
            class: "btn-primary hidden md:inline-flex text-sm px-4 py-2"
          }, {
            default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
              _createTextVNode(" Order Now ", -1)
            ]))]),
            _: 1
          }),
          _createElementVNode("button", {
            class: "md:hidden p-2 rounded-xl hover:bg-cream-200",
            "aria-label": "Toggle menu",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.mobileOpen = !_ctx.mobileOpen))
          }, [
            (!_ctx.mobileOpen)
              ? (_openBlock(), _createBlock(_component_Bars3Icon, {
                  key: 0,
                  class: "w-6 h-6 text-accent"
                }))
              : (_openBlock(), _createBlock(_component_XMarkIcon, {
                  key: 1,
                  class: "w-6 h-6 text-accent"
                }))
          ])
        ])
      ]),
      _createVNode(_Transition, {
        "enter-active-class": "transition duration-150 ease-out",
        "enter-from-class": "opacity-0 -translate-y-2",
        "enter-to-class": "opacity-100 translate-y-0",
        "leave-active-class": "transition duration-100 ease-in",
        "leave-from-class": "opacity-100 translate-y-0",
        "leave-to-class": "opacity-0 -translate-y-2"
      }, {
        default: _withCtx(() => [
          (_ctx.mobileOpen)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createElementVNode("ul", _hoisted_11, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.navLinks, (link) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: link.to
                    }, [
                      _createVNode(_component_router_link, {
                        to: link.to,
                        class: "block px-3 py-2 rounded-xl hover:bg-cream-200 hover:text-brand transition-colors",
                        "active-class": "bg-brand-100 text-brand font-semibold",
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.mobileOpen = false))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(link.label), 1)
                        ]),
                        _: 2
                      }, 1032, ["to"])
                    ]))
                  }), 128))
                ]),
                _createVNode(_component_router_link, {
                  to: "/menu",
                  class: "btn-primary w-full mt-3 text-sm",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.mobileOpen = false))
                }, {
                  default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                    _createTextVNode(" Order Now ", -1)
                  ]))]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ])
  ]))
}